import React from 'react';
import { Badge } from '@mantine/core';
import { EmotionalToneBadgeProps } from './EmotionalToneBadge.types';

/**
 * EmotionalToneBadge Component
 *
 * Displays a colored badge for emotional tone (Positive, Negative, Neutral)
 * Extracted from CustomerDashboard for reusability
 *
 * Usage:
 * ```tsx
 * <EmotionalToneBadge tone="Positive" />
 * <EmotionalToneBadge tone="Negative" variant="filled" size="lg" />
 * ```
 */
export const EmotionalToneBadge: React.FC<EmotionalToneBadgeProps> = ({
  tone,
  variant = 'light',
  size = 'md',
  onClick
}): React.ReactElement => {
  const getColor = (): string => {
    switch (tone) {
      case 'Positive':
        return 'green';
      case 'Negative':
        return 'red';
      case 'Neutral':
        return 'gray';
      default:
        return 'gray';
    }
  };

  const getLabel = (): string => {
    return tone;
  };

  return (
    <Badge color={getColor()} variant={variant} size={size} onClick={onClick}>
      {getLabel()}
    </Badge>
  );
};
